import React from 'react';
import { TextField, FormLabel, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormHelperText } from '@mui/material';
import { t } from '../../constants/translationHelper';

const StyledTextField = styled(TextField)(({ theme }) => ({
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '4px',
        height: '35px',
        '& fieldset': {
            border: 'none',
        },
        '&:hover fieldset': {
            border: 'none',
        },
        '&.Mui-focused fieldset': {
            border: 'none',
        },
    },
    '& .MuiInputBase-input': {
        padding: '0 0',
        // color: '#64728c',

    },
}));

const CustomTextField = ({ name, value, onChange, fieldLabel, required, helperText, placeholder, tagLine,
    // type = 'text',
    type,
    InputProps, readOnly = false, ...props }) => {



    return (
        <Box style={{ marginBottom: '1px' }}>
            <Box sx={{ display: "flex", alignItems: "baseline" }}>
                <FormLabel style={fieldLabelstyle}>   {fieldLabel ? t(fieldLabel) : ""}   </FormLabel>
                <Typography sx={tagLineStyle}>    {tagLine ? t(tagLine) : ""}</Typography>
            </Box>
            <StyledTextField
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder ? t(placeholder) : ""}
                type={type}
                variant="outlined"
                style={required ? { ...style, ...requiredStyle } : style}
                {...props}
                InputProps={{
                    ...InputProps, // Spread existing props (if any)
                    readOnly: readOnly ? true : undefined, // Conditionally add readOnly
                }} />
            {/* <FormHelperText error={true} style={helperTextStyle}> {helperText ? t(helperText) : ""} </FormHelperText> */}
            <FormHelperText error={true} style={helperTextStyle}>
                {helperText
                    ? t(typeof helperText === "string" ? helperText : helperText?.message || "")
                    : ""}
            </FormHelperText>

        </Box>
    );
};



export default CustomTextField;
const style = {
    width: '100%',
    border: '1px solid #CED4DA',
    borderRadius: '4px',
    paddingLeft: '10px',
    height: '35px',
    marginTop: '4px',
    fontFamily: 'Poppins, sans-serif !important',
    color: '#495057',
    fontSize: '14px',
    marginBottom: '3px'
};

const requiredStyle = {
    borderLeft: "2px solid #F27B77",
}

const fieldLabelstyle = {
    color: "#212529",
    fontWeight: "600",
    fontSize: "14px",
    textTransform: "capitalize"

};
const helperTextStyle = {
    fontFamily: 'Poppins, sans-serif !important',
    fontSize: '12px',
    marginTop: 0,
    color: "red",
    textTransform: "capitalize"


}
const tagLineStyle = {
    fontSize: "10px",
    color: "#666",
    paddingLeft: "2px"
};
